// Limite de quantidade de hashtags por plataforma. Diferente de
// `postCaptionLimits.ts` (que limita caracteres), aqui o limite é por
// contagem de hashtags. Só o Instagram tem um limite técnico
// oficialmente documentado (a API rejeita acima de 30) — as demais
// plataformas não impõem um teto formal, então ficam de fora do mapa em
// vez de usar um número não confirmado.
export const POST_HASHTAG_LIMITS: Record<string, number> = {
  instagram: 30,
  instagram_stories: 30,
};

// Entre as plataformas selecionadas, retorna o limite mais restritivo
// (ou undefined se nenhuma das selecionadas tiver um limite documentado).
export function getStrictestHashtagLimit(
  platformIds: string[],
): number | undefined {
  let hard: number | undefined;
  for (const id of platformIds) {
    const limit = POST_HASHTAG_LIMITS[id];
    if (limit === undefined) continue;
    hard = hard === undefined ? limit : Math.min(hard, limit);
  }
  return hard;
}
